export default "/react/logoBannero-9b7e0c2e.png";